module.exports = __webpack_public_path__ + "static/media/u1F913.45bc00b4.png";